import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { TranslateService } from '@ngx-translate/core';
import { DigimatrixService } from '../../services/digimatrix.service';
import { SubscripeSharedDataService } from '../../services/subscripe-shared-data.service';
import { LoginConfirm } from '../../interfaces/login-confirm';
import { map, Observable, Subscription, take, timer } from 'rxjs';
import { ConfirmationService } from 'primeng/api';
import { Router } from '@angular/router';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {

  unsubscribeForm: FormGroup = new FormGroup({});
  isSubmitting: boolean = false
  error: string | undefined = ""
  successOTP?: string;
  phoneMask: string | undefined
  isUnsubscribeConfirm: boolean = false;
  subscribed: boolean = false;
  isunsubscribe: boolean = false;
  phoneNumber: string = ""
  subscription_name: string = ""
  operator?: string = "ELMADAR"
  errorOTP: string | undefined = ""
  otpValue: number | undefined | null
  otpVisible: boolean = true
  countdownDisplay: string = "00:00"
  timerSubscription: Subscription = new Subscription()


  constructor(
    public translate: TranslateService,
    private fb: FormBuilder,
    private digiMatrixService: DigimatrixService,
    private subscripeSharedDataService: SubscripeSharedDataService,
    private confirmationService: ConfirmationService,
    private router: Router,
    private cd: ChangeDetectorRef
  ) { }

  ngOnInit() {

    this.unsubscribeForm = this.fb.group({
      phone: [
        '',
        [
          Validators.required,
          Validators.minLength(12),
          Validators.maxLength(12),
          Validators.pattern('^2189(0|1|2|4|5)[0-9]{7}$')
        ]
      ]
    });

    this.subscripeSharedDataService.phoneNumber.subscribe(val => {
      this.phoneNumber = val
      this.phoneMask = String(val).replace(/.(?=..)/g, 'X')
      if (!val) {
        this.router.navigate(['/home'])
      }
    })

    this.subscripeSharedDataService.subscriptionName.subscribe(val => {
      this.subscription_name = val
    })

    this.phoneMask = String(this.unsubscribeForm.get('phone')?.value).replace(/.(?=..)/g, 'X')
  }

  onUnsubscribe() {
    this.isSubmitting = true;

    if (this.phoneNumber) {
      this.digiMatrixService.unsubscribe(this.phoneNumber).subscribe(resData => {
        if (resData.data.failed) {
          this.error = resData?.data?.failed?.message;
        } else {
          this.successOTP = this.translate.instant('OTP_SENT');
          this.phoneMask = String(this.phoneNumber).replace(/.(?=..)/g, 'X')
          this.isUnsubscribeConfirm = true;
          this.isSubmitting = false;
          const countdownSeconds = 2 * 60; // 2 minutes in seconds

          this.timerSubscription = timer(0, 1000)
            .pipe(
              take(countdownSeconds + 1),
              map((elapsedSeconds) => countdownSeconds - elapsedSeconds)
            )
            .subscribe((remainingSeconds) => {
              const minutes = Math.floor(remainingSeconds / 60);
              const seconds = remainingSeconds % 60;
              this.countdownDisplay = `${this.padZero(minutes)}:${this.padZero(seconds)}`;
            });
        }
      },
        (errorMessage) => {
          this.error = this.translate.instant("ERROR");
        });
    }

  }

  padZero(value: number): string {
    return value < 10 ? `0${value}` : value.toString();
  }

  onUnsubscribeConfirm() {
    this.isSubmitting = true;
    if (this.otpValue) {
      if (typeof this.otpValue !== 'number') {
        this.clearOtp()
        this.isSubmitting = false;
        this.errorOTP = this.translate.instant('OTP_NUMBER');
      } else {
        const authObs: Observable<LoginConfirm> = this.digiMatrixService.unsubscribeConfirm(this.otpValue!, this.phoneNumber);
        authObs.subscribe(
          (resData) => {
            if (resData.data.failed) {
              this.clearOtp()
              this.successOTP = '';
              this.errorOTP = resData?.data?.failed?.message;
              this.isSubmitting = false;
            } else if (resData.data.error?.failed?.message) {
              this.successOTP = '';
              this.clearOtp()
              this.errorOTP = this.translate.instant('OTP_INCORRECT');
              this.isSubmitting = false;
            } else {
              this.subscripeSharedDataService.setIsSubscribed(false)
              this.subscripeSharedDataService.setIsLogin(true)
              this.confirmationService.confirm({
                key: 'confirm',
                rejectVisible: true,
                message: this.translate.instant('UNSUBSCRIPE_SUCCESS'),
                reject: () => {
                  this.router.navigate(["/home"])
                }
              });
              this.errorOTP = '';
              this.isSubmitting = false;
            }
          },
          (errorMessage) => {
            this.error = this.translate.instant("ERROR");
          }
        );
      }
    } else {
      this.errorOTP = this.translate.instant('OTP_INCORRECT');
      this.successOTP = '';
      this.isSubmitting = false;
      this.resetOtpField();

    }

  }

  onLogout() {
    this.subscripeSharedDataService.setPhoneNumber("")
    this.subscripeSharedDataService.setIsSubscribed(false)
    this.subscripeSharedDataService.setIsLogin(true)
    this.router.navigate(["/home"])
  }

  hideOtpPopup() {
    this.isUnsubscribeConfirm = false
  }

  onOtpChange(value: any) {
    if (/^\d+$/.test(value)) {
      this.otpValue = Number(value);
    } else {
      this.clearOtp()
    }
  }

  resetOtpField() {
    this.otpValue = null;
    this.cd.detectChanges();
  }

  clearOtp() {
    this.otpValue = undefined

    this.otpVisible = false;
    setTimeout(() => {
      this.otpVisible = true;
    });
  }
}
